module.exports = __webpack_public_path__ + "dc4a32959c753899810b3ebd792c9a9b.png";